import React from "react";
import { IColuna } from "../../../types/IColuna";
const estiloModalConsultarItens =
  require("../consultar-itens.module.scss").default;

export type HeaderConsultarItensProps = {
  colunas: IColuna[];
};
const traduzirColuna = (nomeColuna: string) => {
  return nomeColuna == "Informações" ? "" : nomeColuna;
};

export const HeaderConsultarItens = (props: HeaderConsultarItensProps) => {
  return (
    <>
      <tr>
        {props.colunas.map(
          (coluna, key) =>
            coluna.Selecionada && (
              <th key={key} className={coluna.Classes}>
                {traduzirColuna(coluna.Nome)}
                {coluna.Selecionada}
              </th>
            )
        )}
        <th></th>
      </tr>
    </>
  );
};
